import { SafeHydrate } from "@/SafeHydrate";
import React, { useEffect } from "react";
import { Phone, Mail, MapPin, Calendar } from 'lucide-react';
import { Button } from "@/components/ui/button";
export default function ContactUs() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
  };
  return <section className="py-16 bg-background">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Contact Us
            </h2>
            <p className="text-base md:text-lg text-muted-dark leading-relaxed max-w-3xl mx-auto">
              Ready to start your health transformation? Get in touch with our expert team. We serve patients throughout Texas via telemedicine..
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl md:text-3xl font-medium text-foreground mb-6">
                  Get in Touch
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-secondary-light-bg rounded-md flex items-center justify-center">
                      <Phone className="w-6 h-6 text-secondary" />
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground mb-1">Call Us</h4>
                      <p className="text-muted-dark">(469) 557-5547</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-accent-light-bg rounded-md flex items-center justify-center">
                      <Mail className="w-6 h-6 text-accent" />
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground mb-1">Email Us</h4>
                      <p className="text-muted-dark">Mike@ironpeakmenshealth.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-primary-light-bg rounded-md flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground mb-1">Location</h4>
                      <p className="text-muted-dark">Serving all of Texas via telemedicine</p>
                    </div>
                  </div>
                </div>

                {}
                <div className="mt-8 pt-6 border-t border-muted-light">
                  <Button onClick={handleCalendlyClick} className="w-full flex items-center justify-center gap-3 bg-accent text-accent-foreground hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 rounded-sm font-semibold transition-all duration-150 h-12 px-6">
                    <SafeHydrate><Calendar className="w-5 h-5" /></SafeHydrate>
                    Schedule a Free Consultation
                  </Button>
                </div>
              </div>
            </div>

            {}<div>•	Step 1: Book your free 30-minute consultation below<br />
              •	Step 2: Complete a brief medical intake form (sent via email)<br />
              •	Step 3: Dr. Flores reviews your history and meets with you via secure video<br /><br />
                <div className="bg-white rounded-md border border-muted-light shadow-soft overflow-hidden">
                  
    
                  <div className="calendly-inline-widget" data-url="https://calendly.com/mfloresdo/30min" style={{
                minWidth: '320px',
                height: '700px'
              }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}